import { Injectable, WritableSignal } from '@angular/core';

import { AlertController } from '@ionic/angular';

import { AppSettingsService } from '@core/services/app-settings/app-settings.service';

import { FingerprintService } from '@pages/auth/pin/services/fingerprint.service';

import { BaseProfileCommand } from '@shared/commands/base-profile.command';
import { IProfileCommandContext } from '@shared/models/profile-command.model';
import { AuthService } from '@shared/services/auth.service';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';

@Injectable()
export class ResetPinCommand extends BaseProfileCommand {
  readonly type = 'resetPin';
  readonly title = 'Сбросить код доступа';
  readonly subtitle?: WritableSignal<string> = undefined;
  readonly icon = 'secure';
  readonly checkbox?: 'unchecked' | 'checked' | 'disabled' | null = null;
  readonly hidden = false;
  readonly group = 'main';
  readonly order = 2;
  readonly settingsNames?: string[] = undefined;

  constructor(
    private alertController: AlertController,
    private authService: AuthService,
    private fingerPrintService: FingerprintService,
    commandAvailabilityService?: CommandAvailabilityService,
    appSettingsService?: AppSettingsService
  ) {
    super(commandAvailabilityService, appSettingsService);
  }

  async execute(_context: IProfileCommandContext): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Сбросить код доступа?',
      message: 'Это действие приведет к выходу из приложения',
      buttons: [
        {
          text: 'Отмена',
          role: 'cancel'
        },
        {
          text: 'Сбросить',
          handler: () => {
            this.resetPin();
          }
        }
      ]
    });

    await alert.present();
  }

  private resetPin(): void {
    // Логика сброса PIN-кода
    this.authService.autoLogin = false;
    this.fingerPrintService.setEnableFingerPrint(false);
    this.authService.clearAuthDataForResetPin();
  }
}
